// this file is automatically generated by git.version.ts script
export const versions = {commit: '3794ab34', tag: '2025.11.003-RELEASE'};
